module.exports = __webpack_public_path__ + "odstraneni-tetovaze_5_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/odstraneni-tetovaze_5_after_tn.jpg
// module id = 1429
// module chunks = 0